/**
 * Based on src/json/defaultTags.json
 * @todo: replace above json with TS objects
 */
export enum IconTypes {
  walkIn = 'walkIn',
  add = 'add',
  addCircle = 'addCircle',
  standbyList = 'standbyList',
  phone = 'phone',
  phoneInTalk = 'phoneInTalk',
  mail = 'mail',
  lock = 'lock',
  unlock = 'unlock',
  tick = 'tick',
  loading = 'loading',
  abc = 'abc',
  autoRenewIcon = 'autoRenewIcon',
  personSearch = 'personSearch',
  repeat = 'repeat',
  loop = 'loop',
  update = 'update',
  restore = 'restore',
  warning = 'warning',
  group = 'group',
  // payment = 'payment',
  // preAuth = 'pre-auth',
  // cardsDiamond = 'cards-diamond',
  // birthday = 'birthday',
  // accessibility = 'accessibility',
  // anniversary = 'anniversary',
  // allergy = 'allergy',
  // highchair = 'highchair',
  // children = 'children',
  // pram = 'pram',
  // dietary = 'dietary',
  // briefcase = 'briefcase',
  // engagement = 'engagement'

  /**
   * DESIGN-V2
   */
  timer = 'timer',
  drawer = 'drawer',
  /**
   * Menu list
   */
  bookings = 'bookings',
  customers = 'customers',
  reports = 'reports',
  new = 'new',
  settings = 'settings',
  admin = 'admin',
  fullScreen = 'fullScreen',
  fullscreenExit = 'fullscreenExit',
  /**
   * Stepper
   */
  stepperLeft = 'stepperLeft',
  stepperRight = 'stepperRight',

  /*
    customer tab
  */
  callOutlinedIcon = 'callOutlinedIcon',
  accountBoxOutlinedIcon = 'accountBoxOutlinedIcon',
  mailOutlineIcon = 'mailOutlineIcon',
  visibilityOutlinedIcon = 'visibilityOutlinedIcon',
  visibilityOffOutlinedIcon = 'visibilityOffOutlinedIcon',
  personOutlineIcon = 'personOutlineIcon',

  /**
   * Booking Summary
   */
  dateRangeIcon = 'dateRangeIcon',
  scheduleIcon = 'scheduleIcon',
  //accountBoxOutlinedIcon : look customer tab
  restaurantIcon = 'restaurantIcon',
  timerIcon = 'timerIcon',
  eventSeatIcon = 'eventSeatIcon', // mat v4 has no icon of design for table
  table = 'table',
  localOfferOutlinedIcon = 'localOfferOutlinedIcon',
  money = 'money',
  serverOff = 'serverOff', // MUI v4 has no icon of design for serverOff
  serverOn = 'serverOn',
  rss = 'rss',
  phoneForwardedIcon = 'phoneForwardedIcon',
  googleIcon = 'googleIcon',
  location = 'location',
  section = 'section',
  bookingOptions = 'bookingOptions',
  apps = 'apps',
  tIcon = 'tIcon',
  arrowDown = 'arrowDown',


  
  repeatServiceIcon = 'repeatServiceIcon',
  /**
   * new customer form
   */
  cakeIcon = 'cakeIcon',
  locationCityIcon = 'locationCityIcon',
  businessIcon = 'businessIcon',
  locationOnOutlinedIcon = 'locationOnOutlinedIcon',
  addIcCallOutlinedIcon = 'addIcCallOutlinedIcon'
}
